/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { ReviewsSorting } from './interface';
import environmentConfig from '@/config/environment';

export const REVIEWS_DEFAULT_SORTING: ReviewsSorting = 'descendingStar';

export const BV_BASE_URL = environmentConfig.BV_BASE_URL;

export const BV_PASS_KEY = environmentConfig.BV_API_KEY;

export const BV_AUTH_CALLBACK_URL =
  environmentConfig.BV_AUTH_CALLBACK_URL ||
  'https://display.ugc.bazaarvoice.com/static/autozone/mobile_site/en_US/container.htm';

//Identifies the page from which the Create Review request is being sent
export const REVIEWS_PAGE_CAMPAIGN_ID = 'REVIEWS_PAGE_TYPE';

export const PDP_CAMPAIGN_ID = 'SITE_PRODUCT_DETAIL_PAGE';

export const ORDER_DETAILS_CAMPAIGN_ID = 'SITE_ORDER_DETAILS';
